import json from "../json/healthStatusGetHealthStatus.json";

export default async () => JSON.parse(JSON.stringify(await json));
